import Form from '../../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class PersonalDetailsSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.personal-details-view');
        this.form = new Form(this.el.querySelector('.personal-details-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
    }

    onSuccess(result) {
        this.form.showSuccess();
        window.HONDA.MyAccount2.client.flushCache('personal-details');
        window.HONDA.MyAccount2.onLogin();
        this.analyticsPush(result);
    }

    onError(result) {
        this.form.showError();
        this.form.hideSuccess();
        this.analyticsPush(result);
    }

    analyticsPush(result) {
        AnalyticsHelper.push({
            event:'form_submit',
            eventCategory:'form submit',
            eventAction:'user profile details submit',
            eventLabel:`${dataLayer[0].productCategory}|My account-save details|Update Details|internal|#`,
            actionType:'user profile details submit',
            businessUnit: dataLayer[0].productCategory,
            moduleName:'My account-save details',
            clickText:'Update Details',
            clickType:'internal', 
            destinationURL: '',
        });
    }
}